import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../utils/context";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import { CancelButton } from "../common/Button";
import ModalSave from "../common/ModelSave";
import ImagePreviewModal from "./ImagePreview";

library.add(fas);

const ViewOffCanvance = ({ handleClose, setShow, show, id, ...props }) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => setValue(newValue);

  const { getData, IMG_URL } = useContext(Context);

  const [data, setData] = useState();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [previewImg, setPreviewImg] = useState(null); // { src, name }

  const { reset } = useForm();

  const getBespokeData = async () => {
    const res = await getData(`/bespoke-order/${id}`);
    setData(res?.data);
    reset(res?.data);
  };

  useEffect(() => {
    if (id) getBespokeData();
  }, [id]);

  const openPreview = (src, name) => setPreviewImg({ src, name });
  const closePreview = () => setPreviewImg(null);

  function ThumbImg({ src, name, IMG_URL, onClick }) {
    return (
      <img
        src={`${IMG_URL}${src}`}
        alt={name}
        width="50px"
        height="50px"
        onClick={onClick}
        style={{
          marginRight: "10px",
          margin: "10px",
          cursor: "pointer",
          borderRadius: "6px",
          border: "2px solid #eee",
          objectFit: "cover",
          transition: "border-color 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#7c4dba")}
        onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#eee")}
      />
    );
  }
  return (
    <>
      <Offcanvas
        show={show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={handleClose}
        className="offcan"
      >
        <Container className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Bespoke Order Details</h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="bespoke order tabs"
                      >
                        <Tab label="Customer Info" value="1" />
                        <Tab label="Gift Details" value="2" />
                        <Tab label="Personalization" value="3" />
                        <Tab label="Order Info" value="4" />
                      </TabList>
                    </Box>

                    {/* ── Tab 1: Customer Info ── */}
                    <TabPanel value="1">
                      <div>
                        <h3>Customer Information</h3>
                        <Row>
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Name</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.name || ""}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Email</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.email || ""}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Contact No.</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.contact_no || ""}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Delivery Address</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.delivery_address || ""}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Preferred Delivery Date</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.delivery_date_id
                                          ? data?.preferred_delivery_date
                                              ?.name || ""
                                          : data?.delivery_date
                                            ? data.delivery_date.split("T")[0]
                                            : ""
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </TabPanel>

                    {/* ── Tab 2: Gift Details ── */}
                    <TabPanel value="2">
                      <div>
                        <h3>Gift Details</h3>
                        <Row>
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Gift Category</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.category?.name || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Occasion</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.occasion?.name || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Budget</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.budget
                                          ? `₹ ${Number(data.budget).toLocaleString("en-IN")}`
                                          : "—"
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Quantity</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.quantity || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Packaging Preference</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.packaging_preference?.name || "—"
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Add-Ons</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.add_ons || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </TabPanel>

                    {/* ── Tab 3: Personalization ── */}
                    <TabPanel value="3">
                      <div>
                        <h3>Personalization</h3>
                        <Row>
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Recipient Name</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.recipient_name || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>
                                  {" "}
                                  Dimensions, Size, and Material
                                </Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.custom_text || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Custom Text / Quote</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.font_style || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          {/* Logo images */}
                          {data?.bespoke_order_logos?.length > 0 && (
                            <Col md={12}>
                              <div className="main-form-section mt-4">
                                <Row>
                                  <Form.Label>Logo / Branding</Form.Label>
                                </Row>
                                {data.bespoke_order_logos.map((img) => (
                                  <ThumbImg
                                    key={img.id}
                                    src={img.image}
                                    name={img.image.split("/").pop()}
                                    IMG_URL={IMG_URL}
                                    onClick={() =>
                                      openPreview(
                                        img.image,
                                        img.image.split("/").pop(),
                                      )
                                    }
                                  />
                                ))}
                              </div>
                            </Col>
                          )}

                          {/* Color / Design images */}
                          {data?.bespoke_order_colors?.length > 0 && (
                            <Col md={12}>
                              <div className="main-form-section mt-4">
                                <Row>
                                  {/* <Form.Label>
                                    Color / Design Preference
                                  </Form.Label> */}
                                  <Form.Label>Logo</Form.Label>
                                </Row>
                                {data.bespoke_order_colors.map((img) => (
                                  <ThumbImg
                                    key={img.id}
                                    src={img.image}
                                    name={img.image.split("/").pop()}
                                    IMG_URL={IMG_URL}
                                    onClick={() =>
                                      openPreview(
                                        img.image,
                                        img.image.split("/").pop(),
                                      )
                                    }
                                  />
                                ))}
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </TabPanel>

                    {/* ── Tab 4: Order Info ── */}
                    <TabPanel value="4">
                      <div>
                        <h3>Order Information</h3>
                        <Row>
                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>
                                  Font Style / Engraving Type
                                </Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.order_reference || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>{" "}
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Payment Mode</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={data?.payment_mode || "—"}
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Order Status</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.status === 1
                                          ? "Pending"
                                          : "Completed"
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Order Date</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.createdAt?.split("T")[0] || ""
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="main-form-section mt-4">
                              <Row className="justify-content-center">
                                <Form.Label>Last Updated</Form.Label>
                                <Form.Group>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      value={
                                        data?.updatedAt?.split("T")[0] || ""
                                      }
                                      disabled
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card.Body>
            </Card>
          </Offcanvas.Body>

          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <CancelButton name={"Back"} handleClose={handleClose} />
            </div>
          </Row>
        </Container>
      </Offcanvas>

      {previewImg && (
        <ImagePreviewModal
          show={!!previewImg}
          onHide={closePreview}
          imgSrc={previewImg.src}
          imgName={previewImg.name}
          IMG_URL={IMG_URL}
        />
      )}

      <ModalSave
        message={showModal?.message}
        showErrorModal={showModal?.code ? true : false}
      />
    </>
  );
};

export default ViewOffCanvance;
